import { useLocale } from '@shared/composables';
import type { Validator } from './types';

export function TValidatorMessage (qicValidator: Omit<Validator, 'validator'>, params: { [key in string]: string } = {}): string {
  const { t, te } = useLocale();
  const hasTranslation = !!qicValidator.messageT && te(qicValidator.messageT);

  try {
    if (
      !hasTranslation &&
      qicValidator.messageT !== undefined &&
      process.env.NODE_ENV !== 'production'
    ) console.warn(`${qicValidator.messageT} validator i18n variable was not found. Default message was used`)
  } catch (err) {
    console.log('process.env was not found')
  }
  

  return hasTranslation && !!qicValidator.messageT ? t(qicValidator.messageT, params) : qicValidator.message;
};
